import { createSlice } from '@reduxjs/toolkit'
import NewsThumb from '@Static/images/news-thumbnail.jpg'
export type Sentiment = {
  positive: number
  negative: number
  neutral: number
}

export type NewsItem = {
  id: number
  thumbnail?: string
  date: string
  title: string
  isSignificant: boolean
  tags: string[]
  linkedMarkets: { name: string; value: number }[]
  sentiment: Sentiment
  content: string
  source: string
}

export type NewsBlock = {
  id: number
  title: string
  news: NewsItem[]
}

export type NewsFeed = NewsBlock[]

export const mockNewsFeed: NewsFeed = [
  {
    id: 1,
    title: 'Major news',
    news: [
      {
        id: 1,
        thumbnail: NewsThumb,
        date: '2025-12-09T08:15:00Z',
        title: 'Bitcoin breaks above $80k as demand surges, breaks above $80k as demand surges',
        isSignificant: true,
        tags: ['BTC', 'Crypto', 'Macro'],
        linkedMarkets: [
          { name: 'BTC/USD', value: 3.2 },
          { name: 'BTC/EUR', value: 2.8 },
        ],
        sentiment: { positive: 72, negative: 10, neutral: 18 },
        source: 'Reuters news',
        content:
          'Bitcoin broke above the $80,000 level as spot and derivatives demand surged across major exchanges. Analysts point to growing institutional flows and renewed interest from retail traders as key drivers behind the latest rally.',
      },
      {
        id: 2,
        thumbnail: NewsThumb,
        date: '2025-12-09T07:40:00Z',
        title: 'Fed hints at slower pace of rate cuts',
        isSignificant: true,
        tags: ['USD', 'Rates', 'Macro'],
        linkedMarkets: [
          { name: 'EUR/USD', value: -0.6 },
          { name: 'DXY', value: 0.4 },
        ],
        sentiment: { positive: 30, negative: 45, neutral: 25 },
        source: 'Reuters news',
        content:
          'The Federal Reserve signaled a slower pace of future rate cuts, citing resilient economic data and sticky core inflation. Markets reacted with modest dollar strength and mixed performance across risk assets.',
      },
      {
        id: 3,
        thumbnail: NewsThumb,
        date: '2025-12-09T06:05:00Z',
        title: 'Ethereum gas fees jump on meme coin frenzy',
        isSignificant: true,
        tags: ['ETH', 'DeFi'],
        linkedMarkets: [
          { name: 'ETH/USD', value: 1.9 },
          { name: 'ETH/BTC', value: 0.7 },
        ],
        sentiment: { positive: 55, negative: 15, neutral: 30 },
        source: 'Reuters news',
        content:
          'Gas fees on the Ethereum network spiked as meme coin trading volumes surged on DEXs. While traders rushed to capitalize on short-term volatility, long-term users faced higher costs for routine on-chain activity.',
      },
      {
        id: 4,
        thumbnail: NewsThumb,
        date: '2025-12-09T05:20:00Z',
        title: 'Oil falls as inventory data beats expectations',
        isSignificant: true,
        tags: ['Oil', 'Commodities'],
        linkedMarkets: [
          { name: 'Brent', value: -1.3 },
          { name: 'WTI', value: -1.1 },
        ],
        sentiment: { positive: 18, negative: 60, neutral: 22 },
        source: 'Reuters news',
        content:
          'Crude oil prices retreated after inventory data showed a larger-than-expected build in US stockpiles. The move eased some concerns around supply tightness and triggered profit-taking across energy names.',
      },
      {
        id: 5,
        thumbnail: NewsThumb,
        date: '2025-12-09T04:45:00Z',
        title: 'US tech stocks extend record rally',
        isSignificant: true,
        tags: ['Stocks', 'Tech'],
        linkedMarkets: [
          { name: 'NAS100', value: 0.9 },
          { name: 'AAPL', value: 0.6 },
        ],
        sentiment: { positive: 68, negative: 8, neutral: 24 },
        source: 'Reuters news',
        content:
          'US technology stocks extended their record-breaking rally, supported by strong earnings and continued optimism around AI-related growth. Momentum traders remain active, though some strategists warn of stretched valuations.',
      },
      {
        id: 6,
        thumbnail: NewsThumb,
        date: '2025-12-09T03:55:00Z',
        title: 'Gold slips as risk appetite returns',
        isSignificant: true,
        tags: ['Gold', 'Safe haven'],
        linkedMarkets: [{ name: 'XAU/USD', value: -0.7 }],
        sentiment: { positive: 20, negative: 55, neutral: 25 },
        source: 'Reuters news',
        content:
          'Gold prices edged lower as broader risk appetite improved and equities attracted fresh inflows. The pullback comes after a strong run in bullion driven by geopolitical concerns and lower real yields.',
      },
      {
        id: 7,
        thumbnail: NewsThumb,
        date: '2025-12-09T03:10:00Z',
        title: 'JPY weakens after BoJ maintains ultra-loose policy',
        isSignificant: true,
        tags: ['JPY', 'FX'],
        linkedMarkets: [
          { name: 'USD/JPY', value: 0.8 },
          { name: 'EUR/JPY', value: 0.5 },
        ],
        sentiment: { positive: 40, negative: 35, neutral: 25 },
        source: 'Reuters news',
        content:
          'The Japanese yen weakened after the Bank of Japan reaffirmed its ultra-loose policy stance and refrained from signaling imminent tightening. FX markets responded with renewed carry interest in yen crosses.',
      },
      {
        id: 8,
        thumbnail: NewsThumb,
        date: '2025-12-09T02:30:00Z',
        title: 'Major exchange lists new AI token',
        isSignificant: true,
        tags: ['Altcoins', 'AI'],
        linkedMarkets: [{ name: 'AI/USD', value: 15.4 }],
        sentiment: { positive: 76, negative: 5, neutral: 19 },
        source: 'Reuters news',
        content:
          'A leading global exchange announced the listing of a new AI-focused token, triggering a sharp spike in price and trading volume. Early investors see the listing as a key liquidity event for the project.',
      },
      {
        id: 9,
        thumbnail: NewsThumb,
        date: '2025-12-09T01:55:00Z',
        title: 'European stocks rise on upbeat earnings',
        isSignificant: true,
        tags: ['Stocks', 'Europe'],
        linkedMarkets: [
          { name: 'EU50', value: 0.6 },
          { name: 'DE30', value: 0.4 },
        ],
        sentiment: { positive: 62, negative: 12, neutral: 26 },
        source: 'Reuters news',
        content:
          'European equity indices moved higher after a series of upbeat earnings reports from major banks and industrial names. Investors welcomed the guidance, which suggested resilient demand despite macro headwinds.',
      },
      {
        id: 10,
        thumbnail: NewsThumb,
        date: '2025-12-09T01:20:00Z',
        title: 'Crypto fund records biggest weekly inflows since 2021',
        isSignificant: true,
        tags: ['Funds', 'Flows', 'Crypto'],
        linkedMarkets: [
          { name: 'TOTAL Crypto Index', value: 2.1 },
          { name: 'BTC/USD', value: 1.5 },
        ],
        sentiment: { positive: 80, negative: 5, neutral: 15 },
        source: 'Reuters news',
        content:
          'A large digital asset fund reported its biggest weekly inflows since 2021, with capital primarily targeting BTC and large-cap altcoins. The data suggests improving institutional confidence in the asset class.',
      },
    ],
  },
  {
    id: 2,
    title: 'For you',
    news: [
      {
        id: 1,
        date: '2025-12-09T09:10:00Z',
        title: 'BTC funding rates normalize after leverage flush',
        isSignificant: false,
        tags: ['BTC', 'Derivatives'],
        source: 'Reuters news',
        linkedMarkets: [
          { name: 'BTC/USD', value: 0.4 },
          { name: 'PERP BTC', value: 0.2 },
        ],
        sentiment: { positive: 55, negative: 15, neutral: 30 },
        content:
          'Bitcoin perpetual funding rates moved back towards neutral levels after an aggressive leverage flush earlier in the week. The reset reduces the risk of forced liquidations and creates room for a more sustainable trend.',
      },
      {
        id: 2,
        date: '2025-12-09T08:35:00Z',
        title: 'Layer-2 activity hits all-time high',
        source: 'Reuters news',
        isSignificant: false,
        tags: ['L2', 'Scaling', 'ETH'],
        linkedMarkets: [{ name: 'OP/USD', value: 3.1 }],
        sentiment: { positive: 70, negative: 10, neutral: 20 },
        content:
          'Transaction counts and TVL on major Layer-2 networks climbed to new all-time highs, driven by lower fees and improved UX. Developers continue to migrate activity from mainnet as scaling solutions mature.',
      },
      {
        id: 3,
        date: '2025-12-09T07:50:00Z',
        title: 'Altcoin rotation continues into mid-caps',
        isSignificant: false,
        tags: ['Altseason', 'Crypto'],
        source: 'Reuters news',
        linkedMarkets: [
          { name: 'SOL/USD', value: 2.4 },
          { name: 'AVAX/USD', value: 1.8 },
        ],
        sentiment: { positive: 65, negative: 12, neutral: 23 },
        content:
          'Traders are rotating out of mega-caps into mid-cap altcoins as risk appetite broadens across the market. Several Layer-1 and DeFi names posted outsized gains on the back of renewed speculative interest.',
      },
      {
        id: 4,
        date: '2025-12-09T07:05:00Z',
        title: 'Options traders price in higher BTC volatility',
        isSignificant: false,
        tags: ['Options', 'BTC'],
        source: 'Reuters news',
        linkedMarkets: [{ name: 'BTC Vol Index', value: 4.2 }],
        sentiment: { positive: 45, negative: 25, neutral: 30 },
        content:
          'BTC options skews and implied volatility moved higher as traders positioned for larger price swings into upcoming macro events. Demand for upside calls and downside hedges both increased across major expiries.',
      },
      {
        id: 5,
        date: '2025-12-09T06:20:00Z',
        title: 'DeFi TVL climbs back above $120B',
        isSignificant: false,
        tags: ['DeFi', 'TVL'],
        source: 'Reuters news',
        linkedMarkets: [
          { name: 'UNI/USD', value: 1.1 },
          { name: 'AAVE/USD', value: 0.9 },
        ],
        sentiment: { positive: 72, negative: 8, neutral: 20 },
        content:
          'Total value locked in DeFi protocols recovered above the $120B mark, led by lending platforms and DEXs. The rebound reflects higher token prices and a gradual return of on-chain activity.',
      },
      {
        id: 6,
        date: '2025-12-09T05:45:00Z',
        title: 'Stablecoin dominance slips as traders move into BTC',
        isSignificant: false,
        tags: ['Stablecoins', 'BTC'],
        source: 'Reuters news',
        linkedMarkets: [
          { name: 'USDT.D', value: -0.3 },
          { name: 'BTC.D', value: 0.5 },
        ],
        sentiment: { positive: 50, negative: 20, neutral: 30 },
        content:
          'Stablecoin market dominance edged lower as traders rotated idle capital back into BTC and high-beta altcoins. On-chain data shows net outflows from stablecoins towards spot and derivatives markets.',
      },
      {
        id: 7,
        date: '2025-12-09T05:00:00Z',
        title: 'NFT volumes rebound after multi-month lows',
        isSignificant: false,
        source: 'Reuters news',
        tags: ['NFTs', 'Marketplace'],
        linkedMarkets: [{ name: 'NFT Index', value: 3.8 }],
        sentiment: { positive: 66, negative: 9, neutral: 25 },
        content:
          'NFT trading volumes rebounded from multi-month lows as new collections and gaming-related drops attracted fresh interest. While activity remains below the peak cycle, liquidity conditions have improved.',
      },
      {
        id: 8,
        date: '2025-12-09T04:25:00Z',
        title: 'Your watchlist: three coins breaking resistance',
        isSignificant: false,
        tags: ['Watchlist', 'TA'],
        source: 'Reuters news',
        linkedMarkets: [
          { name: 'LINK/USD', value: 2.2 },
          { name: 'MATIC/USD', value: 1.5 },
        ],
        sentiment: { positive: 61, negative: 14, neutral: 25 },
        content:
          'Several mid-cap coins are breaking key resistance levels on strong volume. Technicians highlight constructive structures on LINK, MATIC and a handful of DeFi names, with clear invalidation levels for risk management.',
      },
      {
        id: 9,
        date: '2025-12-09T03:40:00Z',
        title: 'Funding and OI suggest cautious bullish positioning',
        isSignificant: false,
        tags: ['Derivatives', 'Sentiment'],
        source: 'Reuters news',
        linkedMarkets: [{ name: 'BTC Perp OI', value: 1.0 }],
        sentiment: { positive: 48, negative: 22, neutral: 30 },
        content:
          'Perpetual futures funding rates and open interest data point to cautiously bullish positioning. Leverage has increased, but not yet to levels typically associated with overcrowded or unstable trends.',
      },
      {
        id: 10,
        date: '2025-12-09T03:05:00Z',
        title: 'On-chain data shows continued accumulation by whales',
        isSignificant: false,
        tags: ['On-chain', 'Whales'],
        source: 'Reuters news',
        linkedMarkets: [
          { name: 'BTC/USD', value: 0.9 },
          { name: 'ETH/USD', value: 0.6 },
        ],
        sentiment: { positive: 75, negative: 5, neutral: 20 },
        content:
          'Large on-chain wallets continue to accumulate BTC and ETH on dips, according to tracking dashboards. The steady pace of accumulation is seen as a supportive factor for the broader uptrend.',
      },
      {
        id: 11,
        date: '2025-12-09T02:30:00Z',
        title: 'New airdrop season fuels activity in DeFi',
        isSignificant: false,
        source: 'Reuters news',
        tags: ['Airdrop', 'DeFi'],
        linkedMarkets: [{ name: 'DeFi Index', value: 2.0 }],
        sentiment: { positive: 69, negative: 11, neutral: 20 },
        content:
          'Rumors and announcements of upcoming airdrops have sparked another wave of speculative activity in DeFi protocols. Users are increasing on-chain interactions in hopes of qualifying for future token distributions.',
      },
    ],
  },
  {
    id: 3,
    title: 'All News & Analysis',
    news: [
      {
        id: 1,
        date: '2025-12-09T09:25:00Z',
        title: 'Morning brief: key levels to watch across FX and crypto',
        isSignificant: false,
        source: 'Reuters news',
        tags: ['FX', 'Crypto', 'Overview'],
        linkedMarkets: [
          { name: 'EUR/USD', value: 0.1 },
          { name: 'BTC/USD', value: 0.3 },
        ],
        sentiment: { positive: 40, negative: 15, neutral: 45 },
        content:
          'In today’s morning brief we highlight key technical levels across major FX pairs and crypto markets. Traders are watching support and resistance zones closely ahead of upcoming economic data releases.',
      },
      {
        id: 2,
        date: '2025-12-09T08:50:00Z',
        title: 'Macro weekly: inflation trends and market reaction',
        isSignificant: false,
        tags: ['Macro', 'Inflation'],
        source: 'Reuters news',
        linkedMarkets: [
          { name: 'US10Y', value: 0.2 },
          { name: 'GOLD', value: -0.1 },
        ],
        sentiment: { positive: 35, negative: 30, neutral: 35 },
        content:
          'This week’s macro recap focuses on evolving inflation trends and how bond and equity markets are reacting. While headline inflation continues to cool, services inflation remains a key concern for policymakers.',
      },
      {
        id: 3,
        date: '2025-12-09T08:10:00Z',
        title: 'Technical view: BTC consolidates after breakout',
        isSignificant: false,
        source: 'Reuters news',
        tags: ['BTC', 'Technical'],
        linkedMarkets: [{ name: 'BTC/USD', value: 0.5 }],
        sentiment: { positive: 52, negative: 18, neutral: 30 },
        content:
          'After a strong breakout, BTC has entered a consolidation phase just below recent highs. Chart patterns suggest a healthy pause, with traders watching for either a continuation pattern or a deeper pullback.',
      },
      {
        id: 4,
        date: '2025-12-09T07:30:00Z',
        title: 'Altcoin watch: capital rotates into L1s',
        isSignificant: false,
        tags: ['Altcoins', 'Layer1'],
        source: 'Reuters news',
        linkedMarkets: [
          { name: 'SOL/USD', value: 1.7 },
          { name: 'ATOM/USD', value: 1.2 },
        ],
        sentiment: { positive: 60, negative: 12, neutral: 28 },
        content:
          'Capital continues to rotate from meme coins and smaller caps into more established Layer-1 ecosystems. SOL, ATOM and similar projects are benefiting from renewed interest in scalable base-layer infrastructure.',
      },
      {
        id: 5,
        date: '2025-12-09T06:55:00Z',
        title: 'FX snapshot: dollar index stable ahead of data',
        isSignificant: false,
        source: 'Reuters news',
        tags: ['FX', 'USD'],
        linkedMarkets: [
          { name: 'DXY', value: 0.0 },
          { name: 'GBP/USD', value: 0.1 },
        ],
        sentiment: { positive: 20, negative: 20, neutral: 60 },
        content:
          'The US dollar index traded in a narrow range ahead of key economic data releases. FX traders are reluctant to take large directional bets until there is more clarity on the growth and inflation outlook.',
      },
      {
        id: 6,
        date: '2025-12-09T06:15:00Z',
        title: 'Commodities: copper extends gains on China optimism',
        isSignificant: false,
        source: 'Reuters news',
        tags: ['Commodities', 'Copper', 'China'],
        linkedMarkets: [{ name: 'Copper', value: 0.9 }],
        sentiment: { positive: 58, negative: 17, neutral: 25 },
        content:
          'Copper prices extended their gains as traders reacted to improved Chinese economic data and fresh stimulus headlines. The move supports the view of a gradual recovery in global industrial demand.',
      },
      {
        id: 7,
        date: '2025-12-09T05:35:00Z',
        title: 'Funding update: major DeFi protocols secure new rounds',
        source: 'Reuters news',
        isSignificant: false,
        tags: ['DeFi', 'VC'],
        linkedMarkets: [
          { name: 'UNI/USD', value: 0.7 },
          { name: 'LDO/USD', value: 0.5 },
        ],
        sentiment: { positive: 67, negative: 8, neutral: 25 },
        content:
          'Several leading DeFi protocols announced new funding rounds led by top-tier venture firms. The capital will be used to accelerate product development, improve security and expand ecosystem partnerships.',
      },
      {
        id: 8,
        date: '2025-12-09T05:00:00Z',
        title: 'Stablecoin flows hint at risk-on mood',
        isSignificant: false,
        source: 'Reuters news',
        tags: ['Stablecoins', 'Flows'],
        linkedMarkets: [
          { name: 'USDT.D', value: -0.2 },
          { name: 'BTC/USD', value: 0.4 },
        ],
        sentiment: { positive: 54, negative: 16, neutral: 30 },
        content:
          'On-chain stablecoin flows show increasing movement from stablecoins into risk assets, particularly BTC and large-cap altcoins. Historically, such patterns have preceded periods of stronger market performance.',
      },
      {
        id: 9,
        date: '2025-12-09T04:20:00Z',
        title: 'Weekend wrap: what moved markets while you were away',
        isSignificant: false,
        tags: ['Overview', 'Recap'],
        source: 'Reuters news',
        linkedMarkets: [
          { name: 'BTC/USD', value: 1.1 },
          { name: 'NAS100', value: 0.6 },
        ],
        sentiment: { positive: 49, negative: 21, neutral: 30 },
        content:
          'The weekend saw moderate moves across crypto and equity index futures, with BTC holding gains and tech stocks inching higher. News flow was relatively light, but positioning continued to evolve under the surface.',
      },
      {
        id: 10,
        date: '2025-12-09T03:45:00Z',
        title: 'Analyst picks: three setups to watch this week',
        isSignificant: false,
        tags: ['Ideas', 'Technical'],
        source: 'Reuters news',
        linkedMarkets: [
          { name: 'ETH/USD', value: 0.9 },
          { name: 'XRP/USD', value: 0.7 },
        ],
        sentiment: { positive: 63, negative: 10, neutral: 27 },
        content:
          'Our analysts highlight three technical setups with attractive risk-reward profiles for the week ahead. Each idea includes clear entry zones, invalidation levels and potential upside targets based on recent price action.',
      },
      {
        id: 11,
        date: '2025-12-09T03:05:00Z',
        title: 'Volatility radar: where the biggest moves may come next',
        isSignificant: false,
        source: 'Reuters news',
        tags: ['Volatility', 'Strategy'],
        linkedMarkets: [
          { name: 'VIX', value: 0.3 },
          { name: 'BTC Vol Index', value: 0.8 },
        ],
        sentiment: { positive: 42, negative: 20, neutral: 38 },
        content:
          'A cross-asset look at volatility suggests that pockets of elevated risk remain in crypto and select single-stock names. Traders are watching these areas closely for potential breakout or breakdown scenarios.',
      },
    ],
  },
]

export const initialState: NewsFeed = mockNewsFeed

const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {},
})

export default newsSlice.reducer
